import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

interface Slide {
  image: string;
  badge: string;
  title: string;
  desc: string;
  to: string;
  cta: string;
}

const slides: Slide[] = [
  {
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20hero%20banner%20of%20a%20surreal%20city%20skyline%20folding%20into%20overlapping%20time%20layers%2C%20floating%20architecture%2C%20deep%20blue%20night%20with%20warm%20amber%20glow%2C%20epic%20sci-fi%20atmosphere%2C%20dramatic%20negative%20space%20for%20text&width=1600&height=900&seq=hero-time-fold&orientation=landscape",
    badge: "重磅推荐 · 电影",
    title: "时间折叠",
    desc: "我们把明天，折进了昨天。一部关于遗憾与放手的硬核科幻谜题。",
    to: "/detail/movie-time-fold",
    cta: "查看剧情介绍",
  },
  {
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20hero%20banner%20of%20an%20epic%20fleet%20of%20starships%20sailing%20toward%20a%20brilliant%20distant%20star%20cluster%2C%20vast%20nebula%20backdrop%2C%20deep%20blue%20and%20gold%20highlights%2C%20sense%20of%20grand%20adventure%2C%20dark%20negative%20space%20for%20title&width=1600&height=900&seq=hero-star-ocean&orientation=landscape",
    badge: "热播剧集 · 电视剧",
    title: "星辰大海",
    desc: "人类第一支远航殖民舰队，三代人的星际旅程，只为回答一个问题：家在哪里。",
    to: "/detail/tv-star-ocean",
    cta: "查看剧情介绍",
  },
  {
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20hero%20banner%20of%20a%20submersible%20descending%20into%20a%20bioluminescent%20deep%20ocean%20trench%20with%20volumetric%20light%20beams%2C%20moody%20sci-fi%20mystery%20atmosphere%2C%20deep%20teal%20blue%20with%20subtle%20warm%20highlights%2C%20dark%20negative%20space&width=1600&height=900&seq=hero-deep-echo&orientation=landscape",
    badge: "焦点新片 · 电影",
    title: "深海回声",
    desc: "在声音消失的地方，真相开始回响。用声音拍成的科幻悬疑片。",
    to: "/detail/movie-deep-echo",
    cta: "查看剧情介绍",
  },
  {
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20hero%20banner%20of%20floating%20enchanted%20islands%20above%20a%20glowing%20sea%20with%20mythical%20creatures%2C%20eastern%20mythology%20atmosphere%2C%20vivid%20deep%20blue%20and%20gold%20tones%2C%20dark%20negative%20space%20for%20text&width=1600&height=900&seq=hero-mountain-sea&orientation=landscape",
    badge: "奇幻新剧 · 电视剧",
    title: "山海奇谭",
    desc: "翻过这座山，山海之外还有山海。一本残缺的图志，一场少年的远行。",
    to: "/detail/tv-mountain-sea-tales",
    cta: "查看剧情介绍",
  },
];

export default function HeroCarousel() {
  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    if (paused) return;
    const timer = window.setInterval(() => {
      setIndex((prev) => (prev + 1) % slides.length);
    }, 5500);
    return () => window.clearInterval(timer);
  }, [paused]);

  return (
    <section
      className="relative w-full overflow-hidden bg-primary-950"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
      aria-label="焦点内容轮播"
    >
      <div className="relative h-[520px] w-full md:h-[600px]">
        {slides.map((slide, i) => (
          <div
            key={slide.title}
            className={`absolute inset-0 transition-opacity duration-700 ${
              i === index ? "opacity-100" : "pointer-events-none opacity-0"
            }`}
          >
            <img
              src={slide.image}
              alt={`${slide.title} 焦点图`}
              title={`${slide.title} 影视焦点推荐`}
              className="h-full w-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-primary-950/85 via-primary-950/45 to-primary-950/25" />
            <div className="absolute inset-0 bg-gradient-to-r from-primary-950/70 via-primary-950/20 to-transparent" />
          </div>
        ))}

        <div className="absolute inset-0 flex items-center">
          <div className="w-full px-4 md:px-8">
            <div className="max-w-2xl">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-500 px-3 py-1 text-xs font-semibold text-primary-950">
                <i className="ri-star-smile-line" />
                {slides[index].badge}
              </span>
              <h2 className="mt-4 font-heading text-3xl font-bold leading-tight text-background-50 md:text-5xl">
                {slides[index].title}
              </h2>
              <p className="mt-4 max-w-xl text-sm leading-relaxed text-background-200 md:text-base">
                {slides[index].desc}
              </p>
              <div className="mt-7 flex flex-wrap items-center gap-3">
                <Link
                  to={slides[index].to}
                  className="inline-flex items-center gap-2 rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
                >
                  {slides[index].cta}
                  <i className="ri-arrow-right-line" />
                </Link>
                <Link
                  to="/news"
                  className="inline-flex items-center gap-2 rounded-md border border-background-50/40 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-background-50/10"
                >
                  <i className="ri-newspaper-line" />
                  最新影视资讯
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="absolute bottom-6 left-0 w-full px-4 md:px-8">
          <div className="flex items-center gap-3">
            {slides.map((slide, i) => (
              <button
                key={slide.title}
                type="button"
                aria-label={`切换到第 ${i + 1} 张：${slide.title}`}
                onClick={() => setIndex(i)}
                className={`h-1.5 rounded-full transition-all ${
                  i === index ? "w-10 bg-accent-500" : "w-4 bg-background-50/50 hover:bg-background-50/80"
                }`}
              />
            ))}
            <span className="ml-2 text-xs text-background-200">
              {String(index + 1).padStart(2, "0")} / {String(slides.length).padStart(2, "0")}
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}